module.exports = __webpack_public_path__ + "img/RS.c393c6b2.png";